import * as Actions from '../../actions/settings/type';

const initialState = {
  getPricingLoading: false,
  createPricingLoading: false,
  updatePricingLoading: false,
  deletePricingLoading: false,
  matrices: [],
  createdMatrix: {},
  updatedMatrix: {},
  deletedMatrix: {},
};
const matricReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get all matrices
    case Actions.GET_MATRIXES_REQUEST:
      return {
        ...state,
        getPricingLoading: true,
      };
    case Actions.GET_MATRIXES_SUCCESS:
      return {
        ...state,
        getPricingLoading: false,
        matrices: action?.payload?.data || '',
      };
    case Actions.GET_MATRIXES_FAIL:
      return {
        ...state,
        getPricingLoading: false,
        error: action.payload,
      };

    // Create pricing matrix
    case Actions.ADD_MATRIX_REQUEST:
      return {
        ...state,
        createPricingLoading: true,
      };
    case Actions.ADD_MATRIX_SUCCESS:
      return {
        ...state,
        createPricingLoading: false,
        createdMatrix: action?.payload?.data || {},
      };
    case Actions.ADD_MATRIX_FAIL:
      return {
        ...state,
        createPricingLoading: false,
        error: action.payload,
      };

    // update pricing matrix
    case Actions.UPDATE_MATRIX_REQUEST:
      return {
        ...state,
        updatePricingLoading: true,
      };
    case Actions.UPDATE_MATRIX_SUCCESS:
      return {
        ...state,
        updatePricingLoading: false,
        updatedMatrix: action?.payload?.data || '',
      };
    case Actions.UPDATE_MATRIX_FAIL:
      return {
        ...state,
        updatePricingLoading: false,
        error: action.payload,
      };

    // delete pricing matrix
    case Actions.DELETE_MATRIX_REQUEST:
      return {
        ...state,
        deletePricingLoading: true,
      };
    case Actions.DELETE_MATRIX_SUCCESS:
      return {
        ...state,
        deletePricingLoading: false,
        deletedMatrix: action?.payload?.data || '',
      };
    case Actions.DELETE_MATRIX_FAIL:
      return {
        ...state,
        deletePricingLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_MATRIX_STATE:
      return {
        ...state,
        createdMatrix: {},
        deletedMatrix: {},
        updatedMatrix: {},
      };
    default:
      return state;
  }
};

export default matricReducer;
